import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { from, Observable, of, throwError } from 'rxjs';
import { AppEmpresas } from '../models/appEmpresas.model';
import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { AppConfiguracionEntornoService } from './appConfiguracionEntornoService.service';
import { AppImagenesService } from './appImagenes.service';
import { LivesSessionHelper } from '../helper/livesSessionHelper';
import { SessionHelper } from '../helper/sessionHelper';
import { catchError, switchMap } from 'rxjs/operators';


//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable({ providedIn: 'root' })
export class AppEmpresasService extends HttpClientBaseService implements IServiceBase<AppEmpresas> {



  constructor(
    _http: HttpClient,
    private appEntornoService: AppConfiguracionEntornoService,
    private imagesService: AppImagenesService,
    private _livesSession: LivesSessionHelper,
    private _session: SessionHelper,
  ) {
    super(_http, '/companies/', '', false);


  }

  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppEmpresas>> {
    throw new Error('Method not implemented.');
  }

  /*   getAllModels(): Observable<AppEmpresas[]> {
      return super.getAll<AppEmpresas[]>();
    } */


  /* Obtener empresas del entorno */
  public getAllModelsByEnvironment(environmentId: any): Observable<AppEmpresas[]> {
    const userRoles: string[] = this._session.User.Roles || [];
    const userId = this._livesSession.AspNetUserId;

    // Construir los parámetros de roles
    const rolesParams = userRoles.map(role => `aspNetUserRole=${encodeURIComponent(role)}`).join('&');


    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies?aspNetUserId=${userId}&${rolesParams}&fields=environment&operator=eq&values=${environmentId}`;


    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppEmpresas[]>(url, { headers: headers });

  }

  getAllModels(): Observable<AppEmpresas[]> {
    const environmentId = this._livesSession.EnvironmentId;

    const userRoles: string[] = this._session.User.Roles || [];
    const userId = this._livesSession.AspNetUserId;

    // Construir los parámetros de roles
    const rolesParams = userRoles.map(role => `aspNetUserRole=${encodeURIComponent(role)}`).join('&');


    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies?aspNetUserId=${userId}&${rolesParams}&fields=environment&operator=eq&values=${environmentId}`;



    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppEmpresas[]>(url, { headers: headers });

  }


  public getModel(id: any): Observable<AppEmpresas> {

    const userRoles: string[] = this._session.User.Roles || [];
    const userId = this._livesSession.AspNetUserId;

    // Construir los parámetros de roles
    const rolesParams = userRoles.map(role => `aspNetUserRole=${encodeURIComponent(role)}`).join('&');

    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies?top=1&aspNetUserId=${userId}&${rolesParams}&fields=company1&operator=eq&values=${id}`;

    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<AppEmpresas>(url, { headers: headers });
  }

  public getHrValidatorCompaniesIds(userId: any, enabled: boolean = true): Observable<any> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}hrvalidator/companies?hostelUserId=${userId}&enabled=${enabled}`;

    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    // Realizar la petición GET y devolver el resultado como un Observable
    return this.http.get<any>(url, { headers: headers });
  }


  public updateModel(id: string, data: Partial<AppEmpresas>): Observable<AppEmpresas> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies/${id}`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    const payload = {
      ...data,
      modifiedBy: AppConfig.settings.apiServerPE.system
    };

    if (payload.smtpServerData) {
      payload.smtpServerData.modifiedBy = AppConfig.settings.apiServerPE.system
    }

    // Realizar la petición PATCH y devolver el resultado como un Observable
    return this.http.patch<AppEmpresas>(url, payload, { headers: headers });

  }

  public createModel(data: Partial<AppEmpresas>): Observable<AppEmpresas> {
    let environmentID: string = this._livesSession.EnvironmentId
    let defaultOrigin: string = 'cd236732-1767-4b39-8a05-42d0e6d4b42d';

    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies`;
    // Crear los headers con la clave API
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });




    const payload = {
      company: {
        companyCode: data.companyCode,
        name: data.name,
        pushAcceptText: data.pushAcceptText,
        pushDenyText: data.pushDenyText,
        mailAcceptText: data.mailAcceptText,
        mailDenyText: data.mailDenyText,
        holidayBagAllowed: (data.holidayBagAllowed),
        holidayBagValidator: data.holidayBagValidator,
        advanceAllowed: data.advanceAllowed,
        advanceInitialDay: data.advanceInitialDay,
        advanceLimitDay: data.advanceLimitDay,
        advanceLimitAmount: data.advanceLimitAmount,
        advanceValidator: data.advanceValidator,
        environment: environmentID,
        myreportin: data.myreportin,
        seniorityCompanyDate: data.seniorityCompanyDate,
        sendAutoInvite: data.sendAutoInvite,
      },
      image: {
        name: data.companyImageData.name,
        imageData: data.companyImageData.base64,
        mimeType: data.companyImageData.mimeType,
        origin: defaultOrigin
      },
      stamp: {
        name: data.companyStampData.name,
        imageData: data.companyStampData.base64,
        mimeType: data.companyStampData.mimeType,
        origin: defaultOrigin
      },
      customRedirection: {
        showButtonRedirection: data.customRedirection.showButtonRedirection,
      },
      hrValidators: data.hrValidators,
      netUsers: data.netUsers
    };

    return this.http.post<AppEmpresas>(url, payload, { headers: headers });
    // return this.http.patch<AppEmpresas>(url, data, { headers: headers });
  }

  public createModelOffline(data: Partial<AppEmpresas>): Observable<any> {
    const environmentID: string = this._livesSession.EnvironmentId || '';
    const defaultOrigin: string = 'cd236732-1767-4b39-8a05-42d0e6d4b42d';
    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies/offline/attendance-licence`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return from(Promise.all([
      data.companyImageData?.name
        ? Promise.resolve(data)
        : this.appEntornoService.getModel(environmentID).toPromise()
          .then(entornoResponse => this.imagesService.getModel(entornoResponse.image).toPromise())
          .then(imageResponse => {
            data.companyImageData = {
              base64: imageResponse.imageData,
              base64FullData: `${imageResponse.mimeType}${imageResponse.imageData}`,
              mimeType: imageResponse.mimeType,
              name: imageResponse.name
            };
            return data;
          })
    ])).pipe(
      switchMap(([preparedData]) => {
        const payload = {
          company: {
            name: preparedData.name,
            identifierNumber: preparedData.identifierNumber,
            environment: environmentID,
            myreportin: preparedData.myreportin ?? null
          },
          image: {
            name: preparedData.companyImageData.name,
            imageData: preparedData.companyImageData.base64,
            mimeType: preparedData.companyImageData.mimeType,
            origin: defaultOrigin
          },
          customRedirection: {
            showButtonRedirection: preparedData.customRedirection?.showButtonRedirection,
          },
          netUsers: preparedData.netUsers
        };

        return this.http.post(url, payload, { headers }).pipe(
          catchError((error: HttpErrorResponse) => {
            return throwError(() => error);
          })
        );
      })
    );
  }


  public createModelConnectia(data: Partial<AppEmpresas>): Observable<any> {
    const environmentID: string = this._livesSession.EnvironmentId || '';
    const defaultOrigin: string = 'cd236732-1767-4b39-8a05-42d0e6d4b42d';
    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies/conectia/attendance-licence`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return from(Promise.all([
      data.companyImageData?.name
        ? Promise.resolve(data)
        : this.appEntornoService.getModel(environmentID).toPromise()
          .then(entornoResponse => this.imagesService.getModel(entornoResponse.image).toPromise())
          .then(imageResponse => {
            data.companyImageData = {
              base64: imageResponse.imageData,
              base64FullData: `${imageResponse.mimeType}${imageResponse.imageData}`,
              mimeType: imageResponse.mimeType,
              name: imageResponse.name
            };
            return data;
          })
    ])).pipe(
      switchMap(([preparedData]) => {
        const payload = {
          company: {
            companyCode: preparedData.companyCode,
            name: preparedData.name,
            environment: environmentID,
            sendAutoInvite: preparedData.sendAutoInvite,
            myreportin: preparedData.myreportin ?? null
          },
          image: {
            name: preparedData.companyImageData.name,
            imageData: preparedData.companyImageData.base64,
            mimeType: preparedData.companyImageData.mimeType,
            origin: defaultOrigin
          },
          netUsers: preparedData.netUsers
        };

        return this.http.post(url, payload, { headers }).pipe(
          catchError((error: HttpErrorResponse) => throwError(() => error))
        );
      })
    );
  }


  public checkSharingOrg(companyCode: number): Observable<any> {
    const environmentID: string = this._livesSession.EnvironmentId || '';

    const url = `${AppConfig.settings.apiServerPE.apiUrl}companies/sharing-same-org?environment=${environmentID}&companyCode=${companyCode}`;

    // Aquí NO necesitas añadir el token manualmente si usas HttpClient
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.get<any>(url, { headers });
  }



}
